module.exports = __webpack_public_path__ + "fonts/nunito-sans-extra-light.bc36a872.ttf";